import { Action, createReducer, on } from '@ngrx/store';
import { TFAStoreActions } from './index';
import { TFAState, initialTFAState } from './state';

const reducer = createReducer(
  initialTFAState,
  on(TFAStoreActions.setTFAStatus, (state, action): TFAState => {
    return {
      ...state,
      TFAStatus: action.isEnabled,
      TFAStatusLoaded: true,
      TFAStatusLoading: false
    };
  }),
  on(TFAStoreActions.loadTFAStatus, (state, action): TFAState => {
    return {
      ...state,
      TFAStatusLoaded: false,
      TFAStatusLoading: true
    };
  })
);

export function TFAReducer(state: TFAState | undefined, action: Action) {
  return reducer(state, action);
}
